// export const serverUrl =
//   "https://script.google.com/macros/s/AKfycbwSVZc9xwbywtu7FaNXo8kxXUDXfpVsMtSQMgIBd62feVc4n6O7VhP_RKIV1Pc5Rf0n/exec";
const googleAppsScriptUrl =
  "https://script.google.com/macros/s/AKfycbwX8ACI5s0lVv3cprhDEWbKF86Nd3WWAncyeQR6JZJZSCMXZTlWNQkI5zmBZAE4lg3f/exec";
export const serverUrl = process.env.REACT_APP_API_URL || googleAppsScriptUrl;
export const testUrl =
  "https://script.google.com/macros/s/AKfycbwW_PC-ZKk-4PKK7-uHArZ__2ZZJo5eweyXGqP0iWKmA9MJQIx1_XgQPqA_lyAmIHnM/exec";
export const siteUrl =
  "https://rcssa.github.io/Freshmen-Airport-Pickup-Frontend/";
export const localUrl = "http://localhost:3000/";
